import { j as o } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { FormControl as l, FormLabel as t, RadioGroup as m, Radio as s } from "@mui/joy";
import { memo as p, useCallback as c } from "react";
const d = "undefined", u = /* @__PURE__ */ new Map([[",", "comma"], [";", "semicolon"], ["	", "tab"], ["|", "pipe"]]), x = p(({
  fileValuesDelimiter: a = d,
  setFileValuesDelimiter: r
}) => {
  const i = c((e) => {
    r(e.target.value);
  }, [r]);
  return /* @__PURE__ */ o.jsxs(l, { sx: {
    "--FormLabel-alignSelf": "center",
    "--FormLabel-margin": 0,
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "1rem"
  }, children: [
    /* @__PURE__ */ o.jsx(t, { children: "Column separator" }),
    /* @__PURE__ */ o.jsx(m, { onChange: i, orientation: "horizontal", value: a, children: Array.from(u.entries(), ([e, n]) => /* @__PURE__ */ o.jsx(s, { label: n, value: e }, e)) })
  ] });
});
x.displayName = "FileValuesDelimiterRadioGroup";
export {
  x as default
};
//# sourceMappingURL=FileValuesDelimiterRadioGroup.js.map
